import { AuthInterceptor } from './shared/services/auth-interceptor.service';
import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerGestureConfig } from '@angular/platform-browser';
import { ErrorHandler, NgModule, LOCALE_ID } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AkitaNgDevtools } from '@datorama/akita-ngdevtools';
import { AkitaNgRouterStoreModule } from '@datorama/akita-ng-router-store';
import { environment } from '../environments/environment';
import { SharedModule } from './shared/shared.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppStoreModule } from './store/app-store.module';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import localePtBR from '@angular/common/locales/pt';
import { registerLocaleData, DecimalPipe } from '@angular/common';
import { StompRService } from '@stomp/ng2-stompjs';
import { MatDialogModule } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import type { MatFormFieldDefaultOptions } from '@angular/material/form-field';
import { provideNgxMask, NgxMaskConfig } from 'ngx-mask';
import { provideEcharts } from 'ngx-echarts';
import { GlobalErrorHandler } from './shared/services/global-error-handler.service';
import { provideDaterangepickerLocale } from 'ngx-daterangepicker-bootstrap';
import { documentInputTransform } from './shared/utils/document-utils';
import { BlipSupportHintComponent } from './shared/components/blip-support-hint/blip-support-hint.component';

registerLocaleData(localePtBR);

const maskConfig: Partial<NgxMaskConfig> = {
    validation: false,
    showMaskTyped: false, // Isso impede que o "_" apareça no final
    dropSpecialCharacters: false,
    // Uppercase only when letters are typed (CNPJ alfanumérico); digit-only masks are unaffected.
    inputTransformFn: documentInputTransform,
  };

@NgModule({ declarations: [
        AppComponent
    ],
    exports: [],
    bootstrap: [AppComponent], imports: [BrowserModule,
        SharedModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        environment.production ? [] : AkitaNgDevtools.forRoot(),
        AkitaNgRouterStoreModule,
        AppStoreModule,
        MatDialogModule,
        BlipSupportHintComponent], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        { provide: LOCALE_ID, useValue: 'pt' },
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } },
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {
                // Mantém visual mais próximo do legado (sem mudanças bruscas por componente).
                appearance: 'fill',
                // Coloca mat-error/mat-hint abaixo do campo (comportamento mais próximo do legado).
                // Isso evita o "texto dentro do input" e melhora a leitura.
                subscriptSizing: 'dynamic',
            } as MatFormFieldDefaultOptions,
        },
        { provide: 'LOCALSTORAGE', useFactory: getLocalStorage },
        { provide: HAMMER_GESTURE_CONFIG, useClass: HammerGestureConfig },
        DecimalPipe,
        StompRService,
        provideHttpClient(withInterceptorsFromDi()),
        provideNgxMask(maskConfig),
        provideEcharts(),
        provideDaterangepickerLocale({
            format: 'DD/MM/YYYY',
            separator: ' - ',
            applyLabel: 'Aplicar',
            cancelLabel: 'Cancelar',
            customRangeLabel: 'Personalizado',
            daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
            monthNames: [
              'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
              'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
            ],
            firstDay: 0,
          })
    ] })
export class AppModule { }


export function getLocalStorage() {
  return (typeof window !== 'undefined') ? window.localStorage : null;
}
